import { render, staticRenderFns } from "./CompletionProgress.vue?vue&type=template&id=2bca59d2&scoped=true"
import script from "./CompletionProgress.vue?vue&type=script&lang=js"
export * from "./CompletionProgress.vue?vue&type=script&lang=js"
import style0 from "./CompletionProgress.vue?vue&type=style&index=0&id=2bca59d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca59d2",
  null
  
)

export default component.exports